import React, { useCallback, useEffect, useState } from 'react'

import { FormattedMessage } from 'react-intl'
import FilterTable from '../../../components/FilterTable/FilterTable'
import Table from '../../../components/Table/Table'
import OutlinedButton from '../../../ui/OutlinedButton/OutlinedButton'
import Panel from '../../../ui/Panel/Panel'
import TextDetail from '../../../ui/TextDetail/TextDetail'

import { USER_REFERENCE_URLS } from '../module/constants'
import {
  IUsersReferenceStepTwoProps,
  ManagerTypeFilter,
  OuTypeFilter,
  TypeFilterEntitlements,
  USER_REFERENCE_DETAIL_ENTITLEMENTS_FORM_FILTER,
  USER_REFERENCE_DETAIL_MANAGERS_FORM_FILTER,
  USER_REFERENCE_DETAIL_OUS_FORM_FILTER,
} from './module/constants'

import {
  selectEntitlementsOfBRSelected,
  selectSelectedUser,
  selectUserEntitlements,
  selectUsersManagedList,
  selectUsersManagedLoader,
  selectUserManagers,
  selectUserOus,
} from '../module/selectors'

import {
  entitlementsListBusinessRolesSelectedReset,
  setEntitlementsBRSelected,
  usersAccountRequest,
  usersEntitlementRequest,
  userManagersRequest,
  userOusRequest,
} from '../module/actions'

import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { createUserEntitlementReferenceFieldList } from './module/utils'

import classes from './UsersReferenceStepTwo.module.scss'

import { filter, isEmpty, uniq } from 'ramda'

import CustomModal from '../../../components/Modals/CustomModal/CustomModal'
import messages from './module/messages'
import filterMessages from '../../../translations/filterMessages'
import messagesEntitlementsFilter from './module/messages2'

import {
  ISectionType,
  ITableType,
} from '../../../common/TablesConfiguration/tcConstants'
import FilterTable2 from '../../../components/FilterTable/FilterTable2'
import FilterTable3 from '../../../components/FilterTable/FilterTable3'
import {
  IDENTITY_SYSTEM,
  IDENTITY_SYSTEM_LIST,
  IdentitySystemType,
} from '../../../module/constants'

const formEntitlements: string = USER_REFERENCE_DETAIL_ENTITLEMENTS_FORM_FILTER
const formManagers: string = USER_REFERENCE_DETAIL_MANAGERS_FORM_FILTER
const formOus: string = USER_REFERENCE_DETAIL_OUS_FORM_FILTER

const UsersReferenceStepTwo = (props: IUsersReferenceStepTwoProps) => {
  const {
    selectedUser,
    usersManagedList,
    usersManagedLoader,
    userEntitlements,
    entitlementsOfBRSelected,
    secondaryManagers,
    secondaryOus,
    usersManagedRequest,
    usersEntitlementRequest,
    changeLocation,
    setEntitlementsBRSelected,
    entitlementsListBusinessRolesSelectedReset,
    getUserManagers,
    getUserOus,
  } = props

  const [filterEntitlements, setFilterEntitlements] = useState<any>([])
  const [ouFilter, setOuFilter] = useState<any[]>([])
  const [managerFilter, setManagerFilter] = useState<any[]>([])
  const [showDetailModal, setShowDetailModal] = useState<boolean>(false)
  const [showMultiManagerOu, setShowMultiManagerOu] = useState<boolean>(false)
  const [filteredAccount, setFilteredAccount] = useState<any[]>([])

  const onSubmitEntitlements: any = useCallback((values: any) => {
    const { advancedSearchFilter, allFilter, ...rest } = values
    let valueFilter: any[] = []
    if (values && isEmpty(values)) return setFilterEntitlements([])

    if (advancedSearchFilter) {
      if (!isEmpty(rest)) {
        Object.keys(rest).forEach((element: any) => {
          valueFilter.push({
            id: TypeFilterEntitlements[
              element as keyof typeof TypeFilterEntitlements
            ],
            value:
              element === 'identitySystemIdFilter'
                ? IDENTITY_SYSTEM[rest[element] as keyof typeof IDENTITY_SYSTEM]
                : rest[element],
            operation: 'AND',
          })
        })
      }
    } else {
      valueFilter = [
        { id: 'application_name', value: allFilter, operation: 'OR' },
        { id: 'entitlement_name', value: allFilter, operation: 'OR' },
      ]
    }
    setFilterEntitlements(valueFilter)
  }, [])

  const onSubmitManagersFilter = (values: any) => {
    const { advancedSearchFilter, allFilter, ...rest } = values
    let valueFilter: any[] = []
    if (values && isEmpty(values)) return setManagerFilter([])

    if (!isEmpty(rest)) {
      Object.keys(rest).forEach((element: any) => {
        valueFilter.push({
          id: ManagerTypeFilter[element as keyof typeof ManagerTypeFilter],
          value:
            element === 'identitySystemIdFilter'
              ? IdentitySystemType[rest[element]]
              : rest[element],
          operation: 'AND',
        })
      })
    }
    setManagerFilter(valueFilter)
  }

  const onSubmitOusFilter = (values: any) => {
    const { advancedSearchFilter, allFilter, ...rest } = values
    let valueFilter: any[] = []
    if (values && isEmpty(values)) return setOuFilter([])

    if (!isEmpty(rest)) {
      Object.keys(rest).forEach((element: any) => {
        valueFilter.push({
          id: OuTypeFilter[element as keyof typeof OuTypeFilter],
          value:
            element === 'identitySystemIdFilter'
              ? IdentitySystemType[rest[element]]
              : rest[element],
          operation: 'AND',
        })
      })
    }
    setOuFilter(valueFilter)
  }

  useEffect(() => {
    let userId: any[] = []
    userId.push(selectedUser.code)
    usersEntitlementRequest(userId)
    usersManagedRequest(selectedUser.code!)
    getUserManagers(selectedUser.code)
    getUserOus(selectedUser.code)
    setManagerFilter([])
    setOuFilter([])

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    onSubmitEntitlements({})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userEntitlements])

  const onCloseModal = () => {
    setShowDetailModal(false)
  }

  const onEntitlementDetailClick = (entitlement: any) => {
    if (!entitlement) {
      return
    }
    setFilteredAccount(filteredApplication(entitlement))
    setShowDetailModal(true)
  }

  const filteredApplication = (entitlement: any): any[] => {
    const { application_name: entitlementName, entitlements } = entitlement
    let tempArray: any[] = []
    if (entitlements && entitlements.length > 0) {
      const applicationNames = entitlements.map((el: any) => el.applicationName)
      applicationNames.forEach((el: any) => {
        tempArray = uniq([
          ...tempArray,
          ...filter(
            (user: any) => user.application_name === el,
            usersManagedList
          ),
        ])
      })
    }
    usersManagedList.forEach((account) => {
      if (account.application_name === entitlementName) {
        tempArray.push(account)
      }
    })
    return tempArray
  }

  const handleInfoBR = (id: string, row: any) => {
    const entitlementsTemp = row.original.entitlements
      ? row.original.entitlements
      : []
    setEntitlementsBRSelected(entitlementsTemp)
  }

  const moreInfoClickHandler = () => {
    setShowMultiManagerOu(true)
  }

  return (
    <React.Fragment>
      <CustomModal
        show={entitlementsOfBRSelected && entitlementsOfBRSelected.length > 0}
        title={<FormattedMessage {...messages.entitlementsOfBR} />}
        onClose={entitlementsListBusinessRolesSelectedReset}
        size="xl"
        dataSource={entitlementsOfBRSelected}
      />
      <CustomModal
        show={showMultiManagerOu}
        title={<FormattedMessage {...messages.moreInfoPanelTitle} />}
        onClose={() => setShowMultiManagerOu(false)}
        size="xl"
        message={
          <>
            <Panel title={<FormattedMessage {...messages.managers} />}>
              {secondaryManagers && secondaryManagers.length > 0 ? (
                <>
                  <FilterTable2
                    key={'2F'}
                    messages={{ ...filterMessages, ...messages }}
                    formProps={formManagers}
                    listsFilter={{
                      IDENTITY_SYSTEM_LIST: {
                        list: IDENTITY_SYSTEM_LIST,
                        type: IdentitySystemType,
                      },
                    }}
                    onSubmitProps={(val: any) => onSubmitManagersFilter(val)}
                    isAccordion
                  />
                  <Table
                    key={'2FT'}
                    dataSource={secondaryManagers}
                    filterProps={managerFilter}
                    rowsChangeable={true}
                    showCTAButton={true}
                  />
                </>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <FormattedMessage {...messages.noResultFound} />
                </div>
              )}
            </Panel>
            <br />
            <Panel title={<FormattedMessage {...messages.ous} />}>
              {secondaryOus && secondaryOus.length > 0 ? (
                <>
                  <FilterTable3
                    key={'3F'}
                    messages={{ ...filterMessages, ...messages }}
                    formProps={formOus}
                    listsFilter={{
                      IDENTITY_SYSTEM_LIST: {
                        list: IDENTITY_SYSTEM_LIST,
                        type: IdentitySystemType,
                      },
                    }}
                    onSubmitProps={(val: any) => onSubmitOusFilter(val)}
                    isAccordion
                  />
                  <Table
                    key={'3FT'}
                    dataSource={secondaryOus}
                    filterProps={ouFilter}
                    rowsChangeable={true}
                    showCTAButton={true}
                  />
                </>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <FormattedMessage {...messages.noResultFound} />
                </div>
              )}
            </Panel>
          </>
        }
      />

      <div className={classes['cta_wrapper']}>
        <OutlinedButton
          onClick={() => changeLocation(USER_REFERENCE_URLS.BASE_URL)}
        >
          <FormattedMessage {...messages.CTABack} />
        </OutlinedButton>
      </div>
      {selectedUser && (
        <Panel title={<FormattedMessage {...messages.UserPanelTitle} />}>
          <TextDetail
            limit={2}
            fieldList={createUserEntitlementReferenceFieldList(selectedUser)}
            showInfoBtn={true}
            onMoreInfoClick={moreInfoClickHandler}
          />
        </Panel>
      )}

      {}
      {filteredAccount && filteredAccount.length > 0 && (
        <CustomModal
          title={<FormattedMessage {...messages.applicationModalTitle} />}
          show={showDetailModal}
          onClose={onCloseModal}
          dataSource={filteredAccount}
          size="xl"
        />
      )}
      {!filteredAccount ||
        (filteredAccount.length === 0 && (
          <CustomModal
            title={<FormattedMessage {...messages.applicationModalTitle} />}
            show={showDetailModal}
            onClose={onCloseModal}
            message={<FormattedMessage {...messages.noFilteredAccountFound} />}
          />
        ))}
      {userEntitlements && userEntitlements.length > 0 && (
        <div className={classes['entitlement-panel']}>
          <Panel
            loader={usersManagedLoader}
            title={<FormattedMessage {...messages.EntitlementPanelTitle} />}
          >
            <FilterTable
              messages={{ ...filterMessages, ...messagesEntitlementsFilter }}
              formProps={formEntitlements}
              listsFilter={{
                IDENTITY_SYSTEM_LIST: {
                  list: IDENTITY_SYSTEM_LIST,
                  type: IdentitySystemType,
                },
              }}
              onSubmitProps={(val: any) => onSubmitEntitlements(val)}
              advancedFilter={true}
              isAccordion={true}
              sectionType={ISectionType.EXAMINE_USERS}
              tableType={ITableType.ENTITLEMENTS_TABLE}
              typeFilter={TypeFilterEntitlements}
              simpleFilterFields={['application_name', 'entitlement_name']}
            />
            <Table
              dataSource={userEntitlements}
              rowsChangeable={true}
              filterProps={filterEntitlements}
              showDetail={true}
              onDetailClick={(item: any) => onEntitlementDetailClick(item)}
              violationOfVisibility={true}
              onInfoBR={(id: string, row: any) => handleInfoBR(id, row)}
              isBR
              sectionType={ISectionType.EXAMINE_USERS}
              tableType={ITableType.ENTITLEMENTS_TABLE}
            />
          </Panel>
        </div>
      )}
      <div className={classes['cta_wrapper_bottom']}>
        <OutlinedButton
          onClick={() => changeLocation(USER_REFERENCE_URLS.BASE_URL)}
        >
          <FormattedMessage {...messages.CTABack} />
        </OutlinedButton>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps: any = () =>
  createStructuredSelector({
    selectedUser: selectSelectedUser,
    usersManagedList: selectUsersManagedList,
    usersManagedLoader: selectUsersManagedLoader,
    userEntitlements: selectUserEntitlements,
    entitlementsOfBRSelected: selectEntitlementsOfBRSelected,
    secondaryManagers: selectUserManagers,
    secondaryOus: selectUserOus,
  })

const mapDispatchToProps: any = {
  usersManagedRequest: (userCode: string) => usersAccountRequest(userCode),
  usersEntitlementRequest: (id: any[]) => usersEntitlementRequest(id),
  changeLocation: (url: string) => push(url),
  setEntitlementsBRSelected: (entitlements: any[]) =>
    setEntitlementsBRSelected(entitlements),
  entitlementsListBusinessRolesSelectedReset: () =>
    entitlementsListBusinessRolesSelectedReset(),
  getUserManagers: userManagersRequest,
  getUserOus: userOusRequest,
}

const withConnect: any = connect(mapStateToProps, mapDispatchToProps)

export default withConnect(UsersReferenceStepTwo)
